import { createContext, useContext } from 'react';

export interface MoreSheetState {
  open: boolean;
  openSheet: () => void;
  close: () => void;
  toggle: () => void;
}

const noop = () => {};

/** The More popup is opened from the bottom bar and from the header menu icon; SuRoutes provides the state. */
export const MoreSheetContext = createContext<MoreSheetState>({ open: false, openSheet: noop, close: noop, toggle: noop });

export const useMoreSheet = () => useContext(MoreSheetContext);
